import { InputNumber, Slider } from 'antd';
import React, { memo, useState } from 'react';
import formatCurrencyVND from 'utils/formatCurrencyVND';

interface IProps {
  form: any;
  name: string;
  price: any;
}

const PriceSlider = ({ form, name, price }: IProps) => {
  const [minPrice, setMinPrice] = useState(price?.min);
  const [maxPrice, setMaxPrice] = useState(price?.max);

  const handleMinPriceChange = (value: any) => {
    if (!isNaN(value)) {
      setMinPrice(value);
      form.setFieldsValue({ [name]: [value, maxPrice] });
    }
  };
  const handleMaxPriceChange = (value: any) => {
    if (!isNaN(value)) {
      setMaxPrice(value);
      form.setFieldsValue({ [name]: [minPrice, value] });
    }
  };

  const handleSliderChange = (value: any) => {
    setMinPrice(value[0]);
    setMaxPrice(value[1]);

    form.setFieldsValue({ [name]: [minPrice, value[1]] });
  };
  return (
    <>
      <Slider
        min={price?.min}
        max={price?.max}
        range
        tooltip={{
          formatter: (value: any) => {
            return formatCurrencyVND(value);
          },
        }}
        // defaultValue={[price?.min, price?.max]}
        // defaultValue={[minPrice, maxPrice]}
        onChange={handleSliderChange}
        value={[minPrice, maxPrice]}
      />
      <div className="flex justify-between items-center">
        <InputNumber
          min={price?.min}
          max={price?.max}
          value={minPrice}
          onChange={handleMinPriceChange}
          controls={false}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          }
          parser={(value) => value!.replace(/[^\d]/g, '')}

          //   className="w-[70px] line-clamp-3"
        />
        <InputNumber
          min={price?.min}
          max={price?.max}
          value={maxPrice}
          onChange={handleMaxPriceChange}
          controls={false}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
          }
          parser={(value) => value!.replace(/[^\d]/g, '')}
        />
      </div>
    </>
  );
};

export default memo(PriceSlider);
